import * as React from 'react';
import { connect } from 'react-redux';
import { OutputSelect } from '../components';
import { OutputsHelper, IOutputValue, EOutputLookupContext, EModalType, OutputReferenceHelper, IOutput, EOutputScope } from '../helpers';
import { IDropdownOption } from 'office-ui-fabric-react';
import store from '../store/store';
import types from '../store/types';

class OutputsSelectContainer extends React.Component<any, any> {

	outputSelectIndexChange = (val: string) => {

		store.dispatch({
			type: types.UPDATE_OUTPUT_LOOKUP_REQUEST_INDEX,
			outputLookupIndex: val
		});

	};

	outputSelectIndexConfirm = () => {

		let { outputLookupRequestIndexForOutputId, outputLookupIndex, outputSearchElementId } = this.props.state

		OutputReferenceHelper.outputSelect(outputLookupRequestIndexForOutputId, outputSearchElementId, outputLookupIndex);
	}

	outputSelectIndexCancel = () => {
		
		store.dispatch({
			type: types.SET_INDEX_REQUEST_OUTPUT_ID,
			outputLookupRequestIndexForOutputId: null
		});

	}

	render() {

		let { outputSearchTerm, outputSearchTop, previousOutputBlocks, outputSearchElementId, focusedOutputKey, outputLookupRequestIndexForOutputId, 
			outputLookupIndex } = this.props.state;

		let currentComponentId: string = null;
		if(this.props.modalState) {
			let {actionConfig, controlConfig, sharedJourneyConfig, modal}= this.props.modalState;
			if(modal.openModal === EModalType.SharedJourneyConfig) {
				currentComponentId = sharedJourneyConfig.SharedJourney
				.ComponentId;
			}

		}
		let outputOptions: IDropdownOption[] = OutputsHelper.getFilteredOutputDropdownOptions(this.props.outputs, previousOutputBlocks, outputSearchTerm, currentComponentId);
		let indexOutputOptions: IOutputValue[] = this.props.outputs.filter(o => !o.IsMultiple);		
		let indexSelectOutputOptions: IDropdownOption[] = OutputsHelper.getFilteredOutputDropdownOptions(indexOutputOptions, previousOutputBlocks, "", currentComponentId);
		indexSelectOutputOptions.unshift({key: "00000000-0000-0000-0000-000000000000",text: "No Index"});
		return outputSearchElementId ? 
			<OutputSelect 
				top={ outputSearchTop }
				outputOptions={ outputOptions }
				indexSelectOutputOptions= { indexSelectOutputOptions }
				outputSearchElementId={ outputSearchElementId }
				focusedOutputKey={ focusedOutputKey }
				outputLookupRequestIndexForOutputId = { outputLookupRequestIndexForOutputId }
				outputLookupIndex={ outputLookupIndex }
				outputSelectIndexChange={ this.outputSelectIndexChange }
				outputSelectIndexConfirm={ this.outputSelectIndexConfirm }
				outputSelectIndexCancel={ this.outputSelectIndexCancel }
			/> : null ;

	}

}

const mapStateToProps = (store) => {

	let showAllOutputs = store.modalState.modal.openModal === EModalType.LoopConfig;
	let outputs: IOutputValue[] = OutputsHelper.combineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs, store.modalState.modal.parentLoopId,showAllOutputs);

	if(
		store.outputsState.outputLookupContext === EOutputLookupContext.ControlValidationConfig && 
		store.modalState && store.modalState.controlConfig && store.modalState.controlConfig.control && 
		store.modalState.controlConfig.control.OutputValues && store.modalState.controlConfig.control.OutputValues.length
	) {

		if(!store.modalState.controlConfig.control.ControlId || !store.modalState.controlConfig.control.ControlId.length) {
			outputs = outputs.concat(store.modalState.controlConfig.control.OutputValues)
		}

	}

	let currentComponentId: string = null;

	if(store.modalState) {
		let {sharedJourneyConfig, modal}= store.modalState;
		if(modal.openModal === EModalType.SharedJourneyConfig) {
			currentComponentId = sharedJourneyConfig.SharedJourney
			.ComponentId;
		}
	}

	let outputOptions: IDropdownOption[] = OutputsHelper.getFilteredOutputDropdownOptions(
		outputs, store.outputsState.previousOutputBlocks, store.outputsState.outputSearchTerm, currentComponentId);
	if(
		store.outputsState.outputLookupContext === EOutputLookupContext.VisibilityExpressionConfig &&
		store.modalState && store.modalState.controlConfig && store.modalState.controlConfig.control &&
		store.modalState.controlConfig.control.OutputValues && store.modalState.controlConfig.control.OutputValues.length
	) {
		outputOptions = OutputsHelper.removeSpecifiedOutputOptions(outputOptions, store.modalState.controlConfig.control.OutputValues)
	}

    return {
        outputOptions: outputOptions,
		state: store.outputsState,
		outputs: outputs
    };
};

export default connect<any, any, any>(mapStateToProps)(OutputsSelectContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/output-select.tsx